export class OnlyFiltersSelectedRule {
    filterKeys;
    constructor(filterKeys) {
        this.filterKeys = filterKeys;
    }
    getName() {
        return `OnlyFiltersSelectedRule-${this.filterKeys.join('-')}`;
    }
    async forSearch(dependencies) {
        const seoInfoBase = dependencies.seoInfoBase;
        const filterState = dependencies.filterState;
        return await seoInfoBase.selectionOnlyFor(this.filterKeys, filterState);
    }
    forSitemapGenerator(filterKeyValues) {
        const filterKeys = Array.from(filterKeyValues.keys());
        if (filterKeys.length !== this.filterKeys.length) {
            return Promise.resolve(false);
        }
        if (!filterKeys.every((filterKey) => this.filterKeys.includes(filterKey))) {
            return Promise.resolve(false);
        }
        if (!this.filterKeys.every((filterKey) => filterKeys.includes(filterKey))) {
            return Promise.resolve(false);
        }
        return Promise.resolve(true);
    }
}
